<template>
  <leaveRequestDialog mode="create" :employeeId="employeeId" @saved="$emit('refreshLeaveRequests')" @close="$emit('closeAddLeaveRequestModal')" />
</template>

<script>
import leaveRequestDialog from '@/components/leave_request/Leave_Request_Dialog.vue';

/** New leave request. Keeps the event names used by the dashboards and leave tabs. */
export default {
  name: 'AddLeaveRequestModal',
  components: { leaveRequestDialog },
  props: {
    /** Locks the request to one employee; leave empty to pick one. */
    employeeId: { type: String, default: null },
  },
  emits: ['closeAddLeaveRequestModal', 'refreshLeaveRequests'],
};
</script>
